import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.99643 3.465L12.535 6.00418M13.724 4.81495C14.0607 4.47831 14.2499 4.02169 14.25 3.54554C14.2501 3.06939 14.061 2.61272 13.7243 2.27599C13.3877 1.93927 12.9311 1.75006 12.455 1.75C11.9788 1.74994 11.5222 1.93903 11.1855 2.27568L2.68577 10.7775C2.5379 10.9249 2.42855 11.1065 2.36734 11.3061L2 14L4.6951 13.6333C4.89455 13.5726 5.07606 13.464 5.2237 13.3168L13.724 4.81495Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgPencil;
